import FetchSettings from "../../interfaces/FetchSettings";
import OcontentProvider from "./OcontentProvider";

export default class OcontentIntroTextProvider extends OcontentProvider {
  protected _baseUrl = this.baseUrl + "html-intro-text/";

  async getIntroTextData(name: string): Promise<string> {
    try {
      const url = new URL(this._baseUrl + name + ".txt");
      const settings: FetchSettings = {
        method: "GET",
      };

      const res = await this.request<Response>(url.toString(), settings, true);
      if (res.ok) {
        return await res.text();
      }
    } catch (err) {
      console.error(err);
    }
    return "";
  }
}
